export default __webpack_public_path__ + "static/media/6.e96c0404.png";